module.exports = __webpack_public_path__ + "static/media/img-check.5da4979b.jpg";